import { render, staticRenderFns } from "./304_二维区域和检索-矩阵不可变.md?vue&type=template&id=ece5ad60&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports